import { useState } from "react";
import { collectionColor, colors, colorNames } from "./collections";

const paletteKey = "collection-custom-colors";
const isHex = (value: unknown): value is string => typeof value === "string" && /^#[0-9a-f]{6}$/i.test(value);

export function CollectionColorPicker({ value, onChange, disabled = false }: {
  value: string | null;
  onChange: (color: string) => void;
  disabled?: boolean;
}) {
  const [customColors, setCustomColors] = useState<string[]>(() => {
    try {
      const stored: unknown = JSON.parse(window.localStorage.getItem(paletteKey) ?? "[]");
      return Array.isArray(stored) ? stored.filter(isHex) : [];
    } catch { return []; }
  });
  const selected = collectionColor(value).toLowerCase();
  const palette = [...new Set([...colors, ...customColors, ...(isHex(value) ? [value] : [])].map(color => color.toLowerCase()))];
  const chooseCustomColor = (color: string) => {
    if (disabled || !isHex(color)) return;
    const next = [...new Set([...customColors, color.toLowerCase()])];
    setCustomColors(next);
    try { window.localStorage.setItem(paletteKey, JSON.stringify(next)); } catch { /* The picker also works without browser storage. */ }
    onChange(color);
  };
  return <fieldset className="collection-color-picker" disabled={disabled}>
    <legend>Color</legend>
    <div className="collection-color-options">
      {palette.map(color => {
        const index = colors.findIndex(preset => preset.toLowerCase() === color);
        return <button key={color} type="button" className="collection-color-option"
          aria-label={index >= 0 ? colorNames[index] : `Custom color ${color}`}
          aria-pressed={selected === color} style={{ backgroundColor: color }} onClick={() => onChange(index >= 0 ? colors[index] : color)} />;
      })}
      <label className="collection-custom-color">
        <input type="color" aria-label="Add custom color" value={selected} onChange={event => chooseCustomColor(event.target.value)} />
        <span>Add color</span>
      </label>
    </div>
  </fieldset>;
}

